import { FullWidthLayout } from '@/layouts'
import * as Styled from './legalPolicies.stlye'
import { Typography, styled } from '@mui/material'
import { useTheme } from '@cellectenergy/cellect-react-components'

const CustomTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.corporateColors.primary.white,
}))

export const ManagamentPolicy = () => {
  const theme = useTheme()
  return (
    <FullWidthLayout
      id="free-trial"
      bgColor={theme.palette.common.corporateColors.primary.midNightBlue}
      borderColor="var(--on-primary-dark)"
    >
      <Styled.LegalContainer>
        <Styled.BoxContent>
          <CustomTypography variant="headline-small" fontWeight={500}>
            Management Policy
          </CustomTypography>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="body-medium">
            Our vision guides the path followed by our organization. Therefore, we base our management policy on the
            following statements:
          </CustomTypography>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Regarding the security of information:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                We guarantee the <span className="body-medium weight-medium">confidentiality, integrity,</span> and{' '}
                <span className="body-medium weight-medium">availability</span> of information and services by ensuring
                that only authorized people can access the company&apos;s resources and sources. We achieve this by
                implementing access control policies, encryption, and secure data handling procedures.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                We conduct regular risk assessments to identify potential threats and vulnerabilities to our information
                and services. We prioritize risks and opportunities and implement measures to address them promptly.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                We meet SLAs and established requirements to ensure the availability of information and our services. We
                also have business continuity, and disaster recovery plans to minimize downtime in the event of
                disruptions.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Regarding customer satisfaction:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                Cellect is fully committed to satisfying the needs of its customers. We actively listen to customer
                feedback and strive to exceed their expectations by delivering high-quality services and products.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                Cellect is fully committed to achieving the requirements of the services we provide. We regularly
                monitor and assess our performance to ensure we meet or exceed the agreed-upon service levels.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            We ensure that all our processes comply with:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                Our customers’ information security requirements. We consider their security concerns and implement
                measures to protect their data and privacy.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                The legal information security requirements. We comply with relevant laws and regulations regarding
                information security, privacy, and protection.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                Regulatory information security requirements. We comply with industry-specific regulations.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Regarding continuous improvement:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                We are committed to continuously improving our services, processes, and all security-related topics.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                We regularly review and assess our security policies and procedures and implement improvements based on
                industry best practices.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Regarding the company&apos;s leadership:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                The top management is leading by example and is fully committed to the company&apos;s standards.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                We provide the necessary resources to implement and maintain our security policies and procedures.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Regarding the participation of people:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                All Cellect&apos;s employees have autonomy and the opportunity to participate in the organization&apos;s
                daily operations actively.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                We encourage open communication, teamwork, and collaboration among our employees.
              </CustomTypography>
            </li>
          </ul>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="title-medium" fontWeight={500}>
            Our approach is based on:
          </CustomTypography>
          <ul>
            <li>
              <CustomTypography variant="body-medium">
                Processes: We focus on customer orientation, continuous improvement, and internal communication to
                ensure that our processes are efficient and effective.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                From system to management: We ensure that our processes are interrelated and monitor and measure their
                performance to identify areas for improvement.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                Measurable facts for decision-making: We measure, analyze, and make decisions focused on improving the
                organization&apos;s performance and achieving our objectives.
              </CustomTypography>
            </li>
            <li>
              <CustomTypography variant="body-medium">
                Mutually beneficial relationships with suppliers and partners that provide long-term relationships: We
                establish relationships with our suppliers and partners based on trust, transparency, and shared goals.
                We ensure that our relationships are mutually beneficial and contribute to the organization&apos;s
                success.
              </CustomTypography>
            </li>
          </ul>
          <CustomTypography variant="body-medium" display="flex" alignSelf="flex-end">
            Approved by: Leon Gosh
          </CustomTypography>
        </Styled.BoxContent>
        <Styled.BoxContent>
          <CustomTypography variant="body-medium" display="flex" alignSelf="flex-end">
            22.05.2023
          </CustomTypography>
        </Styled.BoxContent>
      </Styled.LegalContainer>
    </FullWidthLayout>
  )
}
